import merge from 'lodash/merge';

// eslint-disable-next-line no-restricted-syntax -- TODO: legacy function declaration (baseline)
export function reducer(state = {}, action) {
    return action.isEntity && action.response && action.response.entities
        ? merge({}, state, action.response.entities)
        : state;
}

export const selector = state => state.entities;
